import axios from 'axios';

const discount = async (langIsoCode, code, package_id, subscription_type , phone_number) => {
  try {
    const formData = new FormData();

    formData.append('code', code);
    formData.append('package_id', package_id);
    formData.append('subscription_type', subscription_type);
    formData.append('phone', phone_number);

    const response = await axios.post(`/checkCode`, formData, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        lang: langIsoCode
      }
    });
    if (response.status === 200) {
      return response;
    }
  } catch (e) {
    
  }
};

export default discount;
